<h2 matDialogTitle>Extend Session</h2>
<mat-dialog-content>
  You will be logged out in {{counter}}s. Click the button below to continue using the
  application.
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button color="primary" (click)="extendSession()">
    Extend Session
  </button>
</mat-dialog-actions>
